import React, { useState } from "react";
import { observer } from "mobx-react";
import { Button, Divider, Stack } from "@chakra-ui/react";
import { useEffectOnce } from "usehooks-ts";
import { translations } from "@/constants/translations";
import { useStore } from "@/store";
import { useAppNavigate } from "@/routing/useAppNavigate";
import { ValidateCodeForm } from "./ValidateCodeForm";
import { ValidateEmailForm } from "./ValidateEmailForm";
import { H2 } from "@/components/Heading";
import { OverdosePlanningCallout } from "@/components/OverdosePlanningCallout";
import { ExtraUnitsCallout } from "@/components/ExtraUnitsCallout";

export const EmergentSignInPage = observer(() => {
  const { activeLanguage, orderData, setOrderData } = useStore();
  const navigate = useAppNavigate();
  const language = translations.pages["emergent-account"][activeLanguage];
  const [validationEmail, setValidationEmail] = useState("");

  useEffectOnce(() => {
    setOrderData({
      ...orderData,
      ada: "",
    });
  });

  const handleRedirect = () => navigate({ to: "/" });

  const handleValidate = (email: string) => setValidationEmail(email);

  return (
    <Stack
      spacing={{ base: "8", md: "14" }}
      alignItems="center"
      textAlign="center"
    >
      <H2>{language.emergent_direct_account}</H2>

      <Stack
        spacing="8"
        maxW="702px"
        alignItems="center"
      >
        {validationEmail ? (
          <ValidateCodeForm email={validationEmail} />
        ) : (
          <ValidateEmailForm onValidated={handleValidate} />
        )}
      </Stack>

      <Divider />

      <OverdosePlanningCallout />

      <ExtraUnitsCallout />

      <Button onClick={handleRedirect}>{language.return_home}</Button>
    </Stack>
  );
});
